import React, { ReactElement, useMemo } from 'react';
import moment from 'moment';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import Link from 'next/link';
import { ISrcSet, Picture } from '@kursk/components/ui/Picture/Picture';
import styles from './StreamCard.module.scss';
import { IStream } from '@common/redux/types/stream';
import { Orientations } from "@common/utils/constants";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

interface IStreamCardProps {
  stream: IStream;
  orientation?: Orientations;
}

export function StreamCard({ stream, orientation = "desktop" }: IStreamCardProps): ReactElement {
  const imgSrcSet: ISrcSet[] = [
    {
      media: '(max-width: 1199px)',
      width: 335,
      height: 410,
      cropMode: 'noCrop',
    },
    {
      media: '(min-width: 1200px)',
      width: 290,
      height: 360,
      cropMode: 'noCrop',
    },
  ];

  const startDate = useMemo(() => {
    if (stream.start) {
      return moment(stream.start).format('D MMM YYYY, H:mm').toLowerCase();
    }
    return '';
  }, [stream]);

  const showLiveBadge = useMemo(() => {
    return moment().isBetween(moment(stream.start), moment(stream.end));
  }, [stream]);

  return (
    <Link href={`/streams/${stream._id}/${stream.sysName}`}>
      <a>
        <div
          className={styles.wrapper}
        >
          <div className={styles.info}>
            <div className={styles.titleWrap}>
              <ResponsiveEllipsis
                text={stream.name}
                maxLine={orientation === 'desktop' ? 6 : 4}
                ellipsis='...'
                trimRight
                basedOn='letters'
                className={styles.title}
              />
              <LinesEllipsis
                text={stream.description}
                maxLine={3}
                ellipsis='...'
                trimRight
                basedOn='letters'
                className={styles.description}
              />
            </div>
            <div className={styles.date}>{startDate}</div>
            {showLiveBadge && (
              <div className={styles.liveBadge}>
                <span className={styles.liveBadgeText}>Live</span>
              </div>
            )}
          </div>
          <div className={styles.imageWrapper}>
            <Picture className={styles.image} srcSet={imgSrcSet} image={stream.image}/>
            <div className={styles.badge}>Трансляция</div>
          </div>
        </div>
      </a>
    </Link>
  );
}
